// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.1.0 (commit 6981f48b4bc1a71c8dd9bdfe5a2c343f6370243d).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import CancelMyVoteReducer from "./cancel_my_vote_reducer";
import CreateProfileReducer from "./create_profile_reducer";
import CreateRoomReducer from "./create_room_reducer";
import DisconnectCurrentRoomReducer from "./disconnect_current_room_reducer";
import JoinRoomReducer from "./join_room_reducer";
import MakeRoomPermanentReducer from "./make_room_permanent_reducer";
import ProfileSetNameAvatarReducer from "./profile_set_name_avatar_reducer";
import RevealRoomReducer from "./reveal_room_reducer";
import SetParticipantRoleReducer from "./set_participant_role_reducer";
import SetRoomDeckReducer from "./set_room_deck_reducer";
import SetRoomTopicReducer from "./set_room_topic_reducer";
import SubmitFeedbackReducer from "./submit_feedback_reducer";
import UnrevealRoomReducer from "./unreveal_room_reducer";
import VoteForCardReducer from "./vote_for_card_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import MyParticipatingRoomsRow from "./my_participating_rooms_table";
import MyProfileRow from "./my_profile_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  my_participating_rooms: __table({
    name: 'my_participating_rooms',
    indexes: [
    ],
    constraints: [
    ],
  }, MyParticipatingRoomsRow),
  my_profile: __table({
    name: 'my_profile',
    indexes: [
    ],
    constraints: [
    ],
  }, MyProfileRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("cancel_my_vote", CancelMyVoteReducer),
  __reducerSchema("create_profile", CreateProfileReducer),
  __reducerSchema("create_room", CreateRoomReducer),
  __reducerSchema("disconnect_current_room", DisconnectCurrentRoomReducer),
  __reducerSchema("join_room", JoinRoomReducer),
  __reducerSchema("make_room_permanent", MakeRoomPermanentReducer),
  __reducerSchema("profile_set_name_avatar", ProfileSetNameAvatarReducer),
  __reducerSchema("reveal_room", RevealRoomReducer),
  __reducerSchema("set_participant_role", SetParticipantRoleReducer),
  __reducerSchema("set_room_deck", SetRoomDeckReducer),
  __reducerSchema("set_room_topic", SetRoomTopicReducer),
  __reducerSchema("submit_feedback", SubmitFeedbackReducer),
  __reducerSchema("unreveal_room", UnrevealRoomReducer),
  __reducerSchema("vote_for_card", VoteForCardReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.1.0" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

